export default function imagesService(merchantCategoriesService) {
  var categories = [],
    selectedCategories = [],
    treeviewIcons = {
      collapsed: "<i class='fa fa-folder' aria-hidden='true'></i>",
      expanded: "<i class='fa fa-folder-open' aria-hidden='true'></i>",
      leaf: "<i class='fa fa-tag' aria-hidden='true'></i>",
    };

  function getAllCategories() {
    return merchantCategoriesService.getAllCategories().then(function(res) {
      if (res && res.data) {
        categories = res.data;
        categories.categories[0].children.sort(function(a, b) {
          return b.children.length - a.children.length;
        });
      }
      return categories;
    });
  }

  function getNodeParent(node) {
    return categories.categories[0].children.find(function(parent) {
      return node.parentId === parent.id;
    });
  }

  function removeNodeFromSelected(node, tree) {
    var nodeParent = getNodeParent(node);
    removeNode(node);
    var hasNodeSelected = tree.find(function(node) {
      return node.__ivhTreeviewIndeterminate || node.selected;
    });
    if (!hasNodeSelected) {
      selectedCategories.length = 0;
    }
    return;
  }

  function removeNode(node) {
    var index = arrayObjectIndexOf(selectedCategories, node);
    selectedCategories.splice(index, 1);
  }

  function addNodeToSelectedCategories(node, tree) {
    var nodeParent = getNodeParent(node);
    if (arrayObjectIndexOf(selectedCategories, node) === -1) {
      selectedCategories.push(node);
      node.selected = true;
    }
    if (!nodeParent) {
      selectedCategories.length = 0;
      selectedCategories.push(node);
    }
  }

  function arrayObjectIndexOf(arr, obj) {
    for (var i = 0; i < arr.length; i++) {
      if (angular.equals(arr[i], obj)) {
        return i;
      }
    }
    return -1;
  }

  function resetAll(categories) {
    if (categories) {
      selectedCategories = categories;
      return (selectedCategories = categories);
    }
    getAllCategories();
    return (selectedCategories = []);
  }
  return {
    selectedCategories: selectedCategories,
    getAllCategories: getAllCategories,
    treeviewIcons: treeviewIcons,
    getNodeParent: getNodeParent,
    removeNodeFromSelected: removeNodeFromSelected,
    removeNode: removeNode,
    addNodeToSelectedCategories: addNodeToSelectedCategories,
    resetAll: resetAll,
  };
}



// WEBPACK FOOTER //
// ./src/app/images/images.service.js